import * as React from 'react';
import { useDispatch } from 'react-redux';
import { getDocumentHelper } from '../../../../actions/utility-actions';
import { PageBody } from '../../../../components/page-components/PageBody';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageHeading } from '../../../../components/page-components/PageHeading';
import { PagedList } from '../../../../components/paged-list/PagedList';
import { InvoiceSearchFilters } from '../../../../models/accounting/invoices/invoice-search-filters';
import { InvoiceTotals } from '../../../../models/accounting/invoices/invoice-totals';
import { InvoiceDocument } from '../../../../models/accounting/shared/invoice-document';
import { InvoiceExcelDocument } from '../../../../models/accounting/shared/invoice-excel-document';
import { InvoiceRead } from '../../../../models/accounting/shared/invoice-read';
import { InvoiceSummaryDocument } from '../../../../models/accounting/shared/invoice-summary-document';
import { PagedApiResult } from '../../../../models/utilities/paged-request';
import { AccountingSvc } from '../../../../services/accounting-service';
import { StatusCode } from '../../../../utils/api';
import { ApiEndpoints } from '../../../../utils/app-constants';
import { AppUtils } from '../../../../utils/app-utils';
import { InvoiceRow } from '../components/InvoiceRow';
import { InvoiceSummaryDisplay } from '../components/InvoiceSummaryDisplay';
import '../Invoices.scss';

export const InvoiceSearchScene = () => {
   
    const dispatch = useDispatch();
    const [service] = React.useState(new AccountingSvc());
    const [invoiceTotals, setInvoiceTotals] = React.useState(new InvoiceTotals());
    const [filterParams, setFilterParams] = React.useState(new InvoiceSearchFilters());

    const [invoices, setInvoices] = React.useState(() => {
         const initial = new PagedApiResult<InvoiceRead>();
         initial.pagination = filterParams.paginationInfo;
         initial.pagination.reusePaging = true;
         return initial;
    });

    const onExportSearch = async () => {

        const url = AppUtils.convertFiltersToUrl(
            ApiEndpoints.ACCOUNTING_INVOICES_EXPORT, 
            filterParams
        );
        
        const req = new InvoiceExcelDocument(url);
        dispatch(getDocumentHelper(req));
    };

    const downloadInvoice = async (id: number, invNumber: string) => {
        const req = new InvoiceDocument(id, invNumber);
        dispatch(getDocumentHelper(req));
    };

    const downloadSummary = async (id: number, invNumber: string) => {
        const req = new InvoiceSummaryDocument(id, invNumber);
        dispatch(getDocumentHelper(req));
    };

    /**
     * OnSearch handler
     * @param filters The user search filters to apply
     */
    const onSearch = async (filters: InvoiceSearchFilters) => {
        const response = await service.searchInvoices(filters);
        if (response.status === StatusCode.Success) {
            setInvoices(response.data.searches);
            setInvoiceTotals(response.data.totals);
            scrollTo();
        }

        setFilterParams(filters);
    };

    const onParamsUpdate = (itm : any) => {
        setFilterParams(itm);
    };

    const onParamsReset = () => {
        const tmp = new InvoiceSearchFilters();
        setFilterParams(tmp);
    };

    return <PageContent pageName="[ACCOUNTING] Invoice Search">
                <PageHeading>
                    {
                        invoices && invoices.results.length > 0
                        ? <button 
                            className="btn-clear"
                            onClick={ onExportSearch }>
                            <i className="la la-download" />
                            Export
                        </button>
                        : null
                    }
                </PageHeading>
                    <PageBody>
                        <PagedList
                            noResultsMessage="No invoices found, please search again."
                            searchCallback={ onSearch }
                            data={ invoices }
                            filterProps={ filterParams }
                            selectableClass=""
                            onFilterUpdate={ onParamsUpdate }
                            onReset={ onParamsReset }
                            listTopper={() =>
                                <InvoiceSummaryDisplay
                                    totalLabel={ 'Totals' }
                                    summary={ invoiceTotals } />
                            }
                            rowRenderer={(invoice: InvoiceRead) => 
                                <InvoiceRow
                                    key={ invoice.id }
                                    invoice={ invoice } 
                                    downloadAction={ downloadInvoice }
                                    summaryDownloadAction={ downloadSummary }
                                />
                            }
                        /> 
                </PageBody>
            </PageContent>;
};
